import { render } from "./AddNewPartnerField.vue?vue&type=template&id=21e91bd0&scoped=true"
import script from "./AddNewPartnerField.vue?vue&type=script&lang=js"
export * from "./AddNewPartnerField.vue?vue&type=script&lang=js"

import "./AddNewPartnerField.vue?vue&type=style&index=0&id=21e91bd0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e91bd0"]])

export default __exports__